/**
 * Support API
 * RTK Query endpoints for support requests
 */

import { baseApi } from "./baseApi";

/**
 * Support request interface
 */
export interface SupportRequestData {
	subject: string;
	message: string;
}

/**
 * Support request response interface
 */
export interface SupportRequestResponse {
	message: string;
	admins_notified: number;
}

/**
 * Support API endpoints
 */
export const supportApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		/**
		 * Submit a support request
		 * Sends email to all admin users
		 */
		submitSupportRequest: builder.mutation<
			SupportRequestResponse,
			SupportRequestData
		>({
			query: (data) => ({
				url: "/support/",
				method: "POST",
				body: data,
			}),
		}),
	}),
});

// Export hooks
export const { useSubmitSupportRequestMutation } = supportApi;
